import { combineReducers } from "redux";

import actions from "../actions";

const defaultState = {
  loading: true,
  result: null,
  error: null
};


const userActivity = (state = defaultState, action) => {
  switch (action.type) {
    case actions.SET_ACTIVITY_DETAILS:
    //  console.log(action.payload);
      return Object.assign({}, state, {
        loading: false,
        result: action.payload,
        error: null
      });
      case actions.SET_ACTIVITY_LOADING_TRUE:
      //  console.log(action.payload);
        return Object.assign({}, state, {
          loading: true,
          //result: action.payload,
          error: null
        });
        case actions.SET_ACTIVITY_LOADING_FALSE:
        //  console.log(action.payload);
          return Object.assign({}, state, {
            loading: false,
          //  result: action.payload,
            error: null
          });

    default:
      return state;
  }
};


export default userActivity;
